import { useQuery } from "@tanstack/react-query";
import { getAttendanceByID } from "src/redux/api/_hr_attendance.api";
import { AttendanceType } from "src/redux/types/_attendance.type";

export const useAttendanceByEmployeeId = (empId?: number) => {
  return useQuery<AttendanceType[]>({
    queryKey: ["attendance-history", empId],

    queryFn: async () => {
      if (!empId) return [];

      const res = await getAttendanceByID(empId);

      if (res.message?.toLowerCase() !== "success") {
        throw new Error("Failed to fetch attendance");
      }

      return res.data?.attendance ?? [];
    },

    enabled: !!empId,

    staleTime: 1000 * 60 * 5,
  });
};